import { render } from "./ModalTransparent.vue?vue&type=template&id=8c5bec74&scoped=true"
import script from "./ModalTransparent.vue?vue&type=script&lang=js"
export * from "./ModalTransparent.vue?vue&type=script&lang=js"

import "./ModalTransparent.vue?vue&type=style&index=0&id=8c5bec74&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c5bec74"]])

export default __exports__